import React, {Component} from 'react';

import {
  SortableContainer,
  SortableElement,
  SortableHandle,
  arrayMove,
} from 'react-sortable-hoc';

import NKIcon from '@norkart/ikoner'

import './drag.css'
import './planlagte.css'

const DragHandle = SortableHandle(() => <span className="DragHandle"><NKIcon icon="meny" size="1" color="black" /></span>);

const SortableItem = SortableElement(({vannmaaler,valgt, onValgt, fjernMaaler}) => {
    let className = 'vannmaaler list-group-item SortableItem'
    if (valgt) className += ' valgt'
    return (
        <li className={className}>
          <DragHandle />
            <div className="content">
                <span>{vannmaaler.Maalepunktadresse + (' ' + vannmaaler.Husnummer) + (vannmaaler.Husbokstav ? vannmaaler.Husbokstav: '')}</span>
            </div>

            <NKIcon size="1" color="nk-black" icon="soppelbotte"  className="flexBoxRight"  onClick={() => fjernMaaler()}/>
        </li>
      
    );
  });

  const SortableList = SortableContainer(({vannmaalere,valgtPlanlagtMaaler, 
    onPlanlagtMaalerValgt, fjernMaaler}) => {
    if (vannmaalere === undefined) return <div/>
    return (
        <ul className="SortableList planlagte list-group">
            {vannmaalere.map((value,index) =>  (<SortableItem
                 key={value.MaalerId} 
                 vannmaaler={value} 
                 index={index}
                 valgt={valgtPlanlagtMaaler === value.MaalerId} 
                 onValgt={() => onPlanlagtMaalerValgt(value.MaalerId)}
                 fjernMaaler={() => fjernMaaler(value)}/>))}
        </ul>
    );
});

class SortableComponentPlanlagt extends Component {    
    onSortEnd = ({oldIndex, newIndex}) => {
        let arr = arrayMove(this.props.vannmaalere, oldIndex, newIndex)
        this.props.updateItems(arr)
    };

    onDelete = (item) => {
        this.props.fjernMaaler(item);
    };  

    render() {
        return <SortableList
            className="planlagte list-group"
            fjernMaaler={this.onDelete}      
            vannmaalere={this.props.vannmaalere}
            onSortEnd={this.onSortEnd}
            useDragHandle={true}            
            />;
    }
}

export default SortableComponentPlanlagt;


// WEBPACK FOOTER //
// ./src/planlegging/arbeidsliste/rediger/planlagteDnd.jsx